<div class="backDrop center white" *ngIf="visible$ | async">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title text-center">Create mock data</h4>
            </div>
            <div class="modal-body padding-modal">
                <form [formGroup]="form" class="form-vertical row"  data-cy="create-contract-form">
                    <div class="form-group col-md-6">
                        <label>Name</label>
                        <dx-text-box as-validator class="form-control" valueChangeEvent="keyup" formControlName="name" name="name"></dx-text-box>
                    </div>
                    <div class="form-group col-md-6">
                        <label>Link Template</label>
                        <dx-lookup as-validator class="form-control" valueExpr="id" displayExpr="description"
                            [dataSource]="linkTemplates" formControlName="linkTemplateId" name="linkTemplateId">
                        </dx-lookup>
                    </div>
                    <div class="form-group col-md-6">
                        <label>Start Date</label>
                        <dx-date-box as-validator formControlName="startDate" name="startDate"></dx-date-box>
                    </div>
                    <div class="form-group col-md-6">
                        <label>End Date</label>
                        <dx-date-box as-validator formControlName="endDate" name="endDate"></dx-date-box>
                    </div>
                    <div class="form-group col-md-6">
                        <label>Make Transient</label>
                        <dx-check-box as-validator formControlName="isTransient" name="isTransient"></dx-check-box>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary bottom-margin" (click)="ok()">Save</button>
                <button class="btn btn-default bottom-margin" (click)="cancel()">Cancel</button>
            </div>
        </div>
    </div>
</div>
